<template>
  <div>
    <!-- <h2 class="text-center">Charts.js</h2>
    <p class="category text-center">
      Simple yet flexible JavaScript charting for designers &amp; developers.
      Made by our friends from
      <a target="_blank" rel="noopener" href="https://vue-chartjs.org/"
        >Vue Charts.js</a
      >. Please check
      <a
        target="_blank"
        rel="noopener"
        href="https://vue-chartjs.org/guide/#vue-single-file-components"
        >the full documentation</a
      >.
    </p> -->
    <div class="row">

      <div class="col-lg-3 col-md-6" v-for="card in statsCards" :key="card.title">
      <stats-card
        :title="card.title"
        :sub-title="card.subTitle"
        :type="card.type"
        :icon="card.icon"
      >
        <div slot="footer" v-html="card.footer"></div>
      </stats-card>
    </div>

    <!-- <div class="col-lg-3 col-md-6">
      <stats-card
        :title="phase1"
        sub-title="Watts"
        type="info"
        icon="tim-icons icon-chart-bar-32"
      >
        <div slot="footer">
          <i class="tim-icons icon-sound-wave"></i>Phase 1
        </div>
      </stats-card>
    </div>
     <div class="col-lg-3 col-md-6">
      <stats-card
        :title="phase2"
        sub-title="Watts"
        type="info"
        icon="tim-icons icon-chart-bar-32"
      >
        <div slot="footer">
          <i class="tim-icons icon-sound-wave"></i>Phase 1
        </div>
      </stats-card>
    </div> -->

    <!-- <div class="col-lg-3 col-md-6">
      <stats-card
        :title="phase2+phase1"
        sub-title="Watts"
        type="info"
        icon="tim-icons icon-chart-bar-32"
      >
        <div slot="footer">
          <i class="tim-icons icon-sound-wave"></i>Phase 1
        </div>
      </stats-card>
    </div> -->
    

      <div class="col-md-12 ml-auto">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <h5 class="card-category">Energy consumption yearly</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-chart-bar-32 text-primary "></i>Total {{grandtotal}} KWh
            </h3>
            <h3 class="card-title">
              <i class="tim-icons icon-money-coins text-primary "></i>Total ${{(grandtotal*0.17).toFixed(2)}}
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              :chart-data="lineChart1.chartData"
              :gradient-colors="lineChart1.gradientColors"
              :gradient-stops="lineChart1.gradientStops"
              :extra-options="lineChart1.extraOptions"
              :height="200"
              :key="componentKey0"
              
            >
            </line-chart>
          </div>
        </card>
      </div>

     
    </div>

    <div class="row">
      <div class="col-md-8 ml-auto mr-auto">
        <!-- <card class="card-subcategories card-plain"> -->
          <tabs
            type="primary"
            
            square
            centered
            class="row"
          >
            <tab-pane>
              <span slot="label"
              v-on:click="change(0)">
                <i class="tim-icons icon-watch-time"></i>24H
              </span>
  
      
            </tab-pane>

            <tab-pane>
              <span slot="label"
              v-on:click="change(1)">
                <i class="tim-icons icon-single-copy-04"></i>30D
              </span>
              
            </tab-pane>

            <tab-pane>
              <span slot="label"
              v-on:click="change(2)">
                <i class="tim-icons icon-zoom-split"></i>Custom
              </span>

              <div class="row">

                 

                  <div class="col-md-6 ml-auto mr-auto">
 <base-input>
  
  <el-date-picker v-model="from"
                    type="datetime"
                    placeholder="Select date and time from">
    </el-date-picker>
</base-input> 

</div>
<div class="col-md-6 ml-auto mr-auto">

 <base-input>
  <el-date-picker v-model="to"
                    type="datetime"
                    placeholder="Select date and time to">
    </el-date-picker>
</base-input>


              </div>
<div class="col-6">
              <base-button class="animation-on-hover" 
          type="success"
                    
                  @click.native="load()"   
        >Load</base-button>
        </div>
              </div>
            
            </tab-pane>
          </tabs>
        <!-- </card> -->
      </div>
    </div>
    <p></p>
    <br>

      <!-- <div class="row" v-if="selected ===2">
        <div class="col-md-8 ml-auto mr-auto">
  <base-input>
  
  <el-date-picker v-model="from"
                    type="datetime"
                    placeholder="Select date and time from">
    </el-date-picker>
</base-input> 
 <base-input>
  <el-date-picker v-model="to"
                    type="datetime"
                    placeholder="Select date and time to">
    </el-date-picker>
</base-input>
</div>
        </div> -->

    <div class="row">
      <div class="col-md-12 ml-auto" v-if="selected ===0">
        <card class="card-chart">
          <template slot="header">
            <h5 class="card-category">Energy consupmtion in last 24 hours</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-watch-time text-danger "></i> {{total24}} Wh
            </h3>
            <h3 class="card-title">
              <i class="tim-icons icon-money-coins text-info "></i>${{(total24*.17/1000).toFixed(2)}} 
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              :labels="lineChart2.labels"
              :chart-data="lineChart2.chartData"
              :extra-options="lineChart2.extraOptions"
              :height="200"
               :key="componentKey"
            >
            </line-chart>
            <!-- <bar-chart
              :chart-data="barChart1.chartData"
              :extra-options="barChart1.extraOptions"
              :gradient-colors="barChart1.gradientColors"
              :gradient-stops="barChart1.gradientStops"
              :height="200"
            > 
            </bar-chart>-->
          </div>
        </card>
      </div>
       <div class="col-md-12 ml-auto" v-if="selected ===1">
        <card class="card-chart">
          <template slot="header">
            <h5 class="card-category">Energy consupmtion in last 30 days</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-single-copy-04 text-danger "></i> {{total30.toFixed(2)}} Wh
            </h3>
            <h3 class="card-title">
              <i class="tim-icons icon-money-coins text-info "></i>${{(total30*.17/1000).toFixed(2)}} 
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              :labels="lineChart3.labels"
              :chart-data="lineChart3.chartData"
              :extra-options="lineChart3.extraOptions"
              :height="200"
               :key="componentKey2"
            >
            </line-chart>
            <!-- <bar-chart
              :chart-data="barChart1.chartData"
              :extra-options="barChart1.extraOptions"
              :gradient-colors="barChart1.gradientColors"
              :gradient-stops="barChart1.gradientStops"
              :height="200"
            > 
            </bar-chart>-->
          </div>
        </card>
      </div>

       <div class="col-md-12 ml-auto" v-if="selected ===2">
        <card class="card-chart">
          <template slot="header">
            <h5 class="card-category">Energy consupmtion custom</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-watch-time text-danger "></i> {{totalcustom}} Wh
            </h3>
            <h3 class="card-title">
              <i class="tim-icons icon-money-coins text-info "></i>${{(totalcustom*.17/1000).toFixed(2)}} 
            </h3>
          </template>
          <div class="chart-area">
            <line-chart
              :labels="lineChart4.labels"
              :chart-data="lineChart4.chartData"
              :extra-options="lineChart4.extraOptions"
              :height="200"
               :key="componentKey3"
            >
            </line-chart>
            <!-- <bar-chart
              :chart-data="barChart1.chartData"
              :extra-options="barChart1.extraOptions"
              :gradient-colors="barChart1.gradientColors"
              :gradient-stops="barChart1.gradientStops"
              :height="200"
            > 
            </bar-chart>-->
          </div>
        </card>
      </div>

      <!-- <div class="col-md-5 mr-auto">
        <card class="card-chart" no-footer-line>
          <template slot="header">
            <h5 class="card-category">Multiple Bars Chart With Grid</h5>
            <h3 class="card-title">
              <i class="tim-icons icon-time-alarm text-warning "></i> 130,000$
            </h3>
          </template>
          <div class="chart-area">
            <bar-chart
              :chart-data="barChart2.chartData"
              :extra-options="barChart2.extraOptions"
              :height="200">
            </bar-chart>
          </div>
        </card>
      </div> -->
    </div>

    <!-- <div class="row">
      <div class="col-md-5 ml-auto">
        <card class="card-chart card-chart-pie">
          <h5 slot="header" class="card-category">Simple Pie Chart</h5>

          <div class="row">
            <div class="col-6">
              <div class="chart-area">
                <pie-chart
                  :chart-data="pieChart1.chartData"
                  :extra-options="pieChart1.extraOptions"
                  :height="120">
                </pie-chart>
              </div>
            </div>

            <div class="col-6">
              <h4 class="card-title">
                <i class="tim-icons  icon-trophy text-success "></i> 10.000$
              </h4>
              <p class="category">A total of $54000</p>
            </div>
          </div>
        </card>
      </div>

      <div class="col-md-5 mr-auto">
        <card class="card-chart card-chart-pie">
          <h5 slot="header" class="card-category">Multiple Pie Chart</h5>

          <div class="row">
            <div class="col-6">
              <div class="chart-area">
                <pie-chart
                  :chart-data="pieChart2.chartData"
                  :extra-options="pieChart2.extraOptions"
                  :height="120"
                >
                </pie-chart>
              </div>
            </div>

            <div class="col-6">
              <h4 class="card-title">
                <i class="tim-icons  icon-tag text-warning "></i> 130,000
              </h4>
              <p class="category">Feedback from 20.000 users</p>
            </div>
          </div>
        </card>
      </div>
    </div> -->
  </div>
</template>
<script>
import LineChart from 'src/components/Charts/LineChart';
import BarChart from 'src/components/Charts/BarChart';
import PieChart from 'src/components/Charts/PieChart';
import config from '@/config';
import * as chartConfigs from '@/components/Charts/config';
import { TabPane, Tabs } from 'src/components';
import {DatePicker, TimeSelect} from 'element-ui'
import moment from 'moment';
import firebase from '../Firebase';
import StatsCard from 'src/components/Cards/StatsCard';

export default {
  components: {
    LineChart,
    BarChart,
    PieChart,
    TabPane,
    Tabs,
    StatsCard,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect
  },
  data() {
    return {
      phase1:'',
      pahse2:'',
      day:'',
      id:0,
     energyf:'',
     energy:'',
      from: '',
      to: '',
      days:[],
       days30:[],
      hours:[],
      hour24:[],
      total24:'',
      total30:'',
      custom:[],
      custom8:[],
      totalcustom:'',
      meter:"",
      grandtotal:0,
      loaded:false,

       datatest:[0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0],
       customhours:[0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0],
      selected:0,
      componentKey: 0,
      componentKey2: 0,
      componentKey3: 0,
      componentKey0: 0,
      lineChart1: {
        chartData: {
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN','JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
          datasets: [
            {
              label: 'Fase 1',
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#be55ed',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0 ,0,0,0, 0,0,0, 0,0,0,]
            },
            {
              label: 'Fase 2',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.info,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#2380f7',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0 ,0,0,0, 0,0,0, 0,0,0,]
            },
             {
              label: 'Total',
              fill: true,
              borderColor: config.colors.danger,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.danger,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#2380f7',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0 ,0,0,0, 0,0,0, 0,0,0,]
            }
          ]
        },
        extraOptions: chartConfigs.purpleChartOptions,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0]
      },
      lineChart2: {
        chartData: {
          labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24'],
          datasets: [
            {
              label: 'Fase 2',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.info,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#2380f7',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0 ,0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0]
            }
          ]
        },
        extraOptions: chartConfigs.lineChartOptionsBlue
      },
      lineChart3: {
        chartData: {
          labels: ['1','2','3','4','5','6','7','8','9','10','11','12','1','2','3','4','5','6','7','8','9','10','11','12'],
          datasets: [
            {
              label: 'Fase 2',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.info,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#2380f7',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0,0]
            }
          ]
        },
        extraOptions: chartConfigs.lineChartOptionsBlue
      },
      lineChart4: {
        chartData: {
          labels: ['1','2','3','4','5','6','7','8','9','10','11','12','1','2','3','4','5','6','7','8','9','10','11','12'],
          datasets: [
            {
              label: 'Fase 2',
              fill: true,
              borderColor: config.colors.info,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.info,
              pointBorderColor: 'rgba(255,255,255,0)',
              pointHoverBackgroundColor: '#2380f7',
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0,0]
            }
          ]
        },
        extraOptions: chartConfigs.lineChartOptionsBlue
      },
      statsCards: [
        {
          title: '0.00',
          subTitle: 'Cost per hour $',
          type: 'warning',
          icon: 'tim-icons icon-bank',
          footer: '<i class="tim-icons icon-money-coins"></i> fixed rate',
          route:''
        },
        {
          title: '0.00',
          subTitle: 'Volts',
          type: 'primary',
          icon: 'tim-icons icon-bulb-63',
          footer: '<i class="tim-icons icon-sound-wave"></i></i>total',
          route:''
        },
        {
          title: '0.00',
          subTitle: 'Watts',
          type: 'info',
          icon: 'tim-icons icon-chart-bar-32',
          footer: '<i class="tim-icons icon-sound-wave"></i>Phase 1',
          route:'/rank'
        },
        {
          title: '0.00',
          subTitle: 'Watts',
          type: 'success',
          icon: 'tim-icons icon-chart-bar-32',
          footer: '<i class="tim-icons icon-sound-wave"></i>Phase 2',
          route:''
        }
      ]
      
      
      
     
    };
  },
  mounted: function () {
  window.setInterval(() => {

    this.statsCards[0].title=((this.phase1+this.phase2)*0.17/1000).toFixed(2);
this.statsCards[1].footer= '<i class="tim-icons icon-sound-wave"></i></i>total '+((this.phase1+this.phase2)).toFixed(2)+" Watts";
    
  }, 5000)
},
 async created(){

 const currentUser = firebase.auth().currentUser
  this.uid = currentUser.uid;

   let meter =  await firebase.database()
    .ref('location').child(currentUser.uid)
    //.ref('manual').child("test")
    .orderByChild('timestamp').limitToFirst(1).once("value");

     meter.forEach(info => {

this.meter = info.child("loc").val()
  
  console.log("dash meter: "+info.child("loc").val())
      });



    firebase.database()
    .ref("smeter").child(this.meter).child("instant")
    //.ref('manual').child("test")
    .on("value", notes => {

   this.statsCards[1].title =notes.child("0_voltage").val();
      this.statsCards[2].title =notes.child("0_power").val();
      this.statsCards[3].title  =notes.child("1_power").val();
   
this.phase1 = parseFloat(notes.child("0_power").val());
this.phase2 = parseFloat(notes.child("1_power").val());
       
   // 

      //   let total  = (parseFloat(notes.child("0_power").val())+parseFloat(notes.child("1_power").val())).toFixed(2);


       // this.meterread()

    });

    //  firebase.database()
    // .ref("smeter").child("shellyem-B9E9D9").child("instant")
    // //.ref('manual').child("test")
    // .on("value", notes => {

   
    //   //  this.statsCards[2].title =notes.child("0_power").val();
    //     this.statsCards[3].title  =notes.val();

       
//this.phase2 = (parseFloat(notes.val())).toFixed(2);
        
        

      //   let total  = (parseFloat(notes.child("0_power").val())+parseFloat(notes.child("1_power").val())).toFixed(2);


        //this.meterread()

    // });


  let currentTime = new Date();

   for (let index = currentTime.getMonth(); index > -1; index--) {
      
 let currentmonth = new Date(moment().subtract(index,'months').startOf('month').unix()*1000);
  
  let databig = await this.getmonthhere(index);
// databig.forEach(me=>{
//   console.log(me);
// })

  this.lineChart1.chartData.datasets[0].data[currentmonth.getMonth()]= databig[0];
  this.lineChart1.chartData.datasets[1].data[currentmonth.getMonth()]= databig[1];
  this.lineChart1.chartData.datasets[2].data[currentmonth.getMonth()]= databig[2];

   }
this.grandtotal =this.lineChart1.chartData.datasets[2].data.reduce((acc, item) => acc + item, 0).toFixed(2)

   this.forceRerender0();

this.hours =[]
for (let hour = 23; hour > -1; hour--) {
  // let time = moment().subtract(hour,'hours')
  this.hours.push(moment().subtract(hour,'hours').format("hA"))
  this.hour24.push(moment().subtract(hour,'hours').hours()) 
}
this.lineChart2.chartData.labels = this.hours;


firebase.database()
   // .ref('manual').child("newmeter")
    .ref('smeter').child(this.meter).child("0_total")
    .orderByChild('timestamp')
    .startAt(moment().subtract(22,'hours')
    .startOf('hour')
    .unix()* 1000-300000).once("value", notes => {

      notes.forEach(note => {
      
        var Time = new Date(note.child("timestamp").val());

//console.log("date"+Time.getHours()+"//"+note.child("0_total").val());
if(Time.getHours()===this.day){
        this.energyf =note.child("0_total").val();
      let subtotal= this.energyf-this.energy;
      let subtotla1=  this.datatest[Time.getHours()];
      let total = subtotal+subtotla1;
    //  console.log("totla: "+total);

        this.datatest[Time.getHours()]= total;
        this.energy = note.child("0_total").val();

      }else{

          if (this.id!==0){

this.datatest[Time.getHours()]= note.child("0_total").val()-this.energy;
this.energy = note.child("0_total").val();
          }
          else{
this.energy = note.child("0_total").val();

          }
          this.id++;
          this.day=Time.getHours();         
        }

      });
   //   this.forceRerender();
console.log("----");
//this.data.filter(function(value, index, arr){ return value.energy > 0;});
this.id=0;
this.total24= this.datatest.reduce((acc, item) => acc + item, 0).toFixed(2);

this.hour24.forEach((numhour,ind)=>{

this.lineChart2.chartData.datasets[0].data[ind]=parseFloat(this.datatest[numhour]).toFixed(2);

})
this.days =[]
for (let dia = 30; dia > -1; dia--) {
  this.days.push(moment().subtract(dia,'days').format("D-MMM"))
  this.days30.push(moment().subtract(dia,'days').format("D"))
}
 this.lineChart3.chartData.labels = this.days;

this.forceRerender();

// this.datatest.forEach((ener,ind) => {

//   // this.datatest[this.id] = parseFloat(ener).toFixed(2);
//   // this.id++;
//   this.lineChart2.chartData.datasets[0].data[ind]=parseFloat(ener).toFixed(2);
// console.log(ind+" - "+ener);


// });

    });
    for (let dia1 = 30; dia1 > -1; dia1--) {

    // console.log(moment().subtract(dia1,'days').startOf('day').unix())
   this.lineChart3.chartData.datasets[0].data[30-dia1]=await this.month(dia1)
   if(dia1%5===0){
this.forceRerender2()

   }

   }

    this.total30 = this.lineChart3.chartData.datasets[0].data.reduce((acc, item) => acc + parseFloat(item), 0)
   

  },

  methods:{
    async getmonthhere(index){

      var alldata=[];
// console.log(index)
//   console.log(moment().subtract(index,'months').startOf('month'))
     let vinit=0,vlast=0,vinit1=0,vlast1=0;

 let init = await firebase.database()
   // .ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("0_total")
 .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
    .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToFirst(1).once("value");
      
      init.forEach(init1 => {
vinit = init1.child("0_total").val()
      });
   
    //  init[0].child("0_total").val();


 let last = await  firebase.database()
 //.ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("0_total")
.orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
.endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToLast(1).once("value");
   last.forEach(init1 => {
vlast = init1.child("0_total").val()
      });

 let energytotal = ((vlast-vinit)/1000).toFixed(2);
alldata.push(energytotal);
//////***** */
 let init1 = await firebase.database()
   // .ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("1_total")
 .orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
    .endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToFirst(1).once("value");
      
      init1.forEach(init11 => {
vinit1 = init11.child("1_total").val()

      });
   
  let last1 = await  firebase.database()
 //.ref('manual').child("newmeter")
 .ref('smeter').child(this.meter).child("1_total")
.orderByChild('timestamp').startAt(moment().subtract(index,'months').startOf('month').unix()*1000-300000)
.endAt(moment().subtract(index,'months').endOf('month').unix()*1000).limitToLast(1).once("value");
   last1.forEach(init11 => {
vlast1 = init11.child("1_total").val()
      });
 let energytotal1 = ((vlast1-vinit1)/1000).toFixed(2);
alldata.push(energytotal1);
let finaltotal =  parseFloat(energytotal)+parseFloat(energytotal1);
if(index===0){
  // this.statsCards[0].title = (finaltotal*.17).toFixed(2);
  //   this.statsCards[1].title = finaltotal.toFixed(2);
  // this.forceRerender();
}

alldata.push(parseFloat(finaltotal.toFixed(2)));

 
       return alldata;
     
    },
   async load(){

let timefrom = new Date(this.from);

let timeto = new Date(this.to);


let a = moment(this.from);
let b = moment(this.to);


console.log(b.diff(a, 'hours'))

let timeframe =b.diff(a, 'hours');

this.custom=[];
this.custom8=[];

if(timeframe>25){

let now = new Date();


let test = moment(now);

let timeframe = test.diff(a, 'days');
let diff = b.diff(a, 'days');


this.lineChart4.chartData.datasets[0].data =[];
  for (let dia1 = timeframe; dia1 > timeframe-diff; dia1--) {

this.custom.push(moment().subtract(dia1,'days').format("D-MMM"))
  this.custom8.push(moment().subtract(dia1,'days').format("D"))

let info = await this.month(dia1);
   this.lineChart4.chartData.datasets[0].data.push(parseFloat(info));
//    if(dia1%5===0){
// this.forceRerender2()

//    }



   }
   this.lineChart4.chartData.labels = this.custom;
this.totalcustom = this.lineChart4.chartData.datasets[0].data.reduce((acc, item) => acc + item, 0).toFixed(2);


this.forceRerender3();
}
else{

this.customhours =[0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0, 0,0,0];

for (let hour = timeframe-1; hour > -1; hour--) {
  // let time = moment().subtract(hour,'hours')
  this.custom.push(moment(this.to).subtract(hour,'hours').format("hA"))
  this.custom8.push(moment(this.to).subtract(hour,'hours').hours()) 
}
this.lineChart4.chartData.labels = this.custom;


firebase.database()
   // .ref('manual').child("newmeter")
    .ref('smeter').child(this.meter).child("0_total")
    .orderByChild('timestamp')
    .startAt(timefrom.valueOf()-300000).endAt(timeto.valueOf()).once("value", notes => {

      notes.forEach(note => {
      
        var Time = new Date(note.child("timestamp").val());

//console.log("date"+Time.getHours()+"//"+note.child("0_total").val());
if(Time.getHours()===this.day){
        this.energyf =note.child("0_total").val();
      let subtotal= this.energyf-this.energy;
      let subtotla1=  this.customhours[Time.getHours()];
      let total = subtotal+subtotla1;
    //  console.log("totla: "+total);

        this.customhours[Time.getHours()]= total;
        this.energy = note.child("0_total").val();

      }else{

          if (this.id!==0){

this.customhours[Time.getHours()]= note.child("0_total").val()-this.energy;
this.energy = note.child("0_total").val();
          }
          else{
this.energy = note.child("0_total").val();

          }
          this.id++;
          this.day=Time.getHours();         
        }

      });
   //   this.forceRerender();
console.log("----");
//this.data.filter(function(value, index, arr){ return value.energy > 0;});
this.id=0;
this.total24= this.datatest.reduce((acc, item) => acc + item, 0).toFixed(2);

this.custom8.forEach((numhour,ind)=>{

this.lineChart4.chartData.datasets[0].data[ind]=parseFloat(this.customhours[numhour]).toFixed(2);

})
this.totalcustom = this.customhours.reduce((acc, item) => acc + item, 0).toFixed(2);


this.forceRerender3();

// this.datatest.forEach((ener,ind) => {

//   // this.datatest[this.id] = parseFloat(ener).toFixed(2);
//   // this.id++;
//   this.lineChart2.chartData.datasets[0].data[ind]=parseFloat(ener).toFixed(2);
// console.log(ind+" - "+ener);


// });

    });

      
}

    },
    forceRerender0(){
      console.log("charts render 0");
      this.componentKey0 += 1;
    },
    forceRerender() {
      console.log("charts render 1");
      this.componentKey += 1;
    },
    forceRerender2() {
      console.log("charts render 2 ");
      this.componentKey2 += 1;
    },
    forceRerender3() {
      console.log("charts render 3 ");
      this.componentKey3 += 1;
    },
   async change(index){
//console.log(index);
this.selected = index;

// if(index===1){
   
// }


this.forceRerender();

    },
  async  month(dia){


      let vinit=0,vlast=0,vinit1=0,vlast1=0;

 let init = await firebase.database()
   // .ref('manual').child("newmeter")
 .ref('smeter').child("shellyem-B9E9D9").child("0_total")
 .orderByChild('timestamp').startAt(moment().subtract(dia,'days').startOf('day').unix()*1000-300000)
    .endAt(moment().subtract(dia,'days').endOf('day').unix()*1000).limitToFirst(1).once("value");
      
      init.forEach(init1 => {
vinit = init1.child("0_total").val()
      });
   
    //  init[0].child("0_total").val();


 let last = await  firebase.database()
 //.ref('manual').child("newmeter")
 .ref('smeter').child("shellyem-B9E9D9").child("0_total")
.orderByChild('timestamp').startAt(moment().subtract(dia,'days').startOf('day').unix()*1000-300000)
.endAt(moment().subtract(dia,'days').endOf('day').unix()*1000).limitToLast(1).once("value");
   last.forEach(init1 => {
vlast = init1.child("0_total").val()
      });

 let energytotal = (vlast-vinit).toFixed(2);

 //console.log(energytotal)

return energytotal;


    }
  }
};
</script>
<style></style>
